module.exports = __webpack_public_path__ + "static/media/clipboard-solid-full.6a9c4fd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/clipboard-solid-full.svg
// module id = 2589
// module chunks = 0